// FxRiskBanner — surfaces the cross-currency FX-volatility warning on the
// deal-detail page when the deal's local currency differs from the user's
// home currency. Quiet on same-currency deals.

import { AlertTriangle, ArrowLeftRight } from "lucide-react";

export default function FxRiskBanner({ currencyView }) {
  if (!currencyView) return null;
  const { local_currency, home_currency, fx_rate_local_per_usd, fx_risk_warning } = currencyView;
  if (!local_currency || local_currency === home_currency) return null;

  const tone = fx_risk_warning?.toLowerCase().includes("high")
    ? "bg-orange-50 border-orange-200 text-orange-900"
    : "bg-amber-50 border-amber-200 text-amber-900";

  return (
    <div
      data-testid="fx-risk-banner"
      className={`flex items-start gap-3 rounded-xl border px-4 py-3 ${tone}`}
    >
      <AlertTriangle className="mt-0.5 h-4 w-4 flex-shrink-0" />
      <div className="flex-1 text-sm leading-relaxed">
        <div className="flex items-center gap-2">
          <span className="font-semibold tracking-tight">Cross-currency exposure</span>
          <span className="inline-flex items-center gap-1 rounded-full bg-white/70 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider">
            <ArrowLeftRight className="h-3 w-3" />
            {local_currency} → {home_currency}
          </span>
          {fx_rate_local_per_usd ? (
            <span className="text-[11px] text-current/70">
              spot: 1 USD = {Number(fx_rate_local_per_usd).toFixed(3)} {local_currency}
            </span>
          ) : null}
        </div>
        <p className="mt-1 text-xs">{fx_risk_warning}</p>
      </div>
    </div>
  );
}
